import { createSlice } from '@reduxjs/toolkit';
import { logoutUserState } from 'store/auth/slices/AuthSlice';

import {
  addToWishListAPI,
  getWishListAPI,
  removeFromWishListAPI,
} from '../actions/CustomerWishListAction';

import { fetchHeaderFooterData } from './CustomerGlobalSlice';

interface WishListState {
  wishListItems: any[];
  totalWishListProducts: number;
  loading: boolean;
}

const initialState: WishListState = {
  wishListItems: [],
  totalWishListProducts: 0,
  loading: false,
};

export const CustomerWishListSlice = createSlice({
  name: 'customerWishList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(logoutUserState, () => initialState)
      // FETCH
      .addCase(getWishListAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWishListAPI.fulfilled, (state, action) => {
        const payloadData = action.payload?.data || action.payload || [];
        const isFirstPage = action.meta.arg?.page === 1 || !action.meta.arg?.page;

        state.loading = false;
        if (isFirstPage) {
          state.wishListItems = payloadData.data;
        } else {
          state.wishListItems = [...state.wishListItems, ...payloadData.data];
        }
        state.totalWishListProducts = payloadData?.total_records ?? state.totalWishListProducts;
      })
      .addCase(getWishListAPI.rejected, (state) => {
        state.loading = false;
      })
      // update qty from global slice
      .addCase(fetchHeaderFooterData.fulfilled, (state, action) => {
        const data = action.payload;
        state.totalWishListProducts = data?.total_wishlist_customers ?? 0;
      })
      // REMOVE
      .addCase(removeFromWishListAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeFromWishListAPI.fulfilled, (state, action) => {
        const data = action.payload?.data || action.payload;
        const removedId = action.meta.arg;
        state.loading = false;
        state.wishListItems = state.wishListItems.filter((item) => item?.product?.id !== removedId);
        state.totalWishListProducts =
          data?.total_wishlist_customers ?? Math.max(0, state.totalWishListProducts - 1);
      })
      .addCase(removeFromWishListAPI.rejected, (state) => {
        state.loading = false;
      })

      // ADD
      .addCase(addToWishListAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(addToWishListAPI.fulfilled, (state, action) => {
        const data = action.payload?.data || action.payload;
        state.loading = false;
        state.totalWishListProducts = data?.total_wishlist_customers ?? state.totalWishListProducts;
      })
      .addCase(addToWishListAPI.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default CustomerWishListSlice.reducer;
